/*
  Barra fija de "Agregar al carrito" en la ficha de producto (2026-08-17).

  Muestra una barra anclada abajo mientras el botón real está fuera de la pantalla.
  El botón de la barra no envía el formulario por su cuenta: pulsa el botón real.

  Antes usaba el atributo form para enviar el mismo <form>, y eso resultó ser un
  error grave: las apps de opciones (Infinite Options) validan interceptando los
  clics del botón real, así que la barra se saltaba la validación y dejaba agregar
  al carrito un Discovery Box sin perfumes elegidos. Al pulsar el botón real, la
  barra hereda todas las validaciones sin conocerlas.

  La barra se inserta en <body> porque la columna de información lleva la animación
  de entrada del tema (transform) y eso rompería el position: fixed.
*/
(function () {
  function init() {
    var wrapper = document.querySelector('.buy-buttons--sticky');
    if (!wrapper) return;

    var form = wrapper.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.hidden = true;

    var button = document.createElement('button');
    // type button, no submit: la barra no envía el formulario, delega en el botón real.
    button.type = 'button';
    button.className = 'button button--full-width button--primary sticky-atc-bar__button';
    button.addEventListener('click', function () {
      var real = wrapper.querySelector('.product-form__submit');
      if (real) real.click();
    });
    bar.appendChild(button);
    document.body.appendChild(bar);
    // Habilita en el CSS la reserva de espacio al pie y la subida del botón de
    // WhatsApp. Va aquí y no en el Liquid para que solo aplique si la barra
    // realmente se montó.
    document.body.classList.add('con-barra-atc');

    // El tema reemplaza el botón al cambiar de variante (texto, agotado, precio),
    // así que hay que volver a leerlo en cada actualización.
    function actualizar() {
      var source = wrapper.querySelector('.product-form__submit');
      if (!source) {
        bar.hidden = true;
        return;
      }

      var label = source.querySelector('span');
      var texto = (label ? label.textContent : source.textContent).trim();
      if (button.textContent !== texto) button.textContent = texto;
      button.disabled = source.disabled;

      var caja = source.getBoundingClientRect();
      var alto = window.innerHeight || document.documentElement.clientHeight;
      var botonALaVista = caja.bottom > 0 && caja.top < alto;
      // Solo se escribe en el DOM cuando el estado cambia de verdad.
      if (bar.hidden !== botonALaVista) bar.hidden = botonALaVista;
    }

    // Se llama directo y no dentro de requestAnimationFrame: rAF queda congelado
    // mientras la pestaña está en segundo plano y la barra se quedaba pegada en
    // el último estado. El trabajo por evento es una sola medición.
    actualizar();
    window.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    new MutationObserver(actualizar).observe(wrapper, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
